import { axiosInstance } from "./axios";
import { ITag, TagType } from "dto/ITag";
import { IError } from "dto/IError";
import useCustomMutation from "hooks/useCustomMutation";
import useCustomQuery from "hooks/useCustomQuery";

const queryKeys = {
  getTags: (
    tagId: number,
    workspaceId?: string,
    currentWorkspaceId?: string
  ) => ["tagsService.getTags", tagId, workspaceId, currentWorkspaceId],
};

const getTags = (
  tagId?: TagType,
  workspaceId?: string,
  currentWorkspaceId?: string
): Promise<{ data: ITag[] }> => {
  const query = new URLSearchParams(window.location.search);

  // inaczej nie łapie się 0
  if (tagId != null) {
    query.append("Type", tagId.toString());
  }

  if (workspaceId) {
    query.append("WorkspaceId", workspaceId);
  }

  if (currentWorkspaceId) {
    query.append("CurrentWorkspaceId", currentWorkspaceId);
  }

  return axiosInstance.get(`/tags?${query}`);
};

const useGetTags = (
  disabled: boolean = false,
  tagId?: TagType,
  workspaceId?: string,
  currentWorkspaceId?: string
) => {
  return useCustomQuery(
    queryKeys.getTags(tagId, workspaceId, currentWorkspaceId),
    () => getTags(tagId, workspaceId, currentWorkspaceId),
    {
      enabled: !disabled,
    }
  );
};

interface IRemoveTagFromPackage {
  TagId: string;
  Items?: { Id: string; Kind: number }[];
}
const removeTagFromPackage = (
  payload: IRemoveTagFromPackage
): Promise<{ data: IError }> => {
  return axiosInstance.delete("/tagged", {
    data: payload,
  });
};

const useRemoveTagFromPackage = () => {
  return useCustomMutation(removeTagFromPackage);
};

export interface IAddTag {
  NewTags: string[] | null;
  Items?: { Id: string; Kind: number }[];
  TagIds: string[];
}

const addTag = (payload: IAddTag): Promise<{ data: ITag[] }> => {
  return axiosInstance.post("/tagged", payload);
};

const useAddTag = () => {
  return useCustomMutation(addTag);
};

export interface ICreateTag {
  Name: string;
  Type: number;
  WorkspaceId?: string;
}

const createTag = (payload: ICreateTag): Promise<{ data: ITag }> => {
  return axiosInstance.post("/tag", payload);
};

const useCreateTag = () => {
  return useCustomMutation(createTag);
};

export interface IRemoveTag {
  Id: string;
}

const deleteTag = (payload: IRemoveTag): Promise<{ data: IError }> => {
  return axiosInstance.delete("/tag", {
    data: payload,
  });
};

const useDeleteTag = () => {
  return useCustomMutation(deleteTag);
};

export interface IEditTag {
  Id: string;
  Name: string;
}

const editTag = (payload: IEditTag): Promise<{ data: ITag }> => {
  return axiosInstance.put("/tag", payload);
};
const useEditTag = () => {
  return useCustomMutation(editTag);
};

export default {
  useGetTags,
  useRemoveTagFromPackage,
  useAddTag,
  useCreateTag,
  useDeleteTag,
  useEditTag,
};
